module.exports = __webpack_public_path__ + "img/team-joined.1045c654.png";